import {
  CopyToClipboard,
  Grid,
  Typography,
  TypographyDate,
} from '@explorer/core';
import { ActiveUserIcon } from '@explorer/icons';
import { ControlClientInfoUser } from '@explorer/open-api-client';
import { appConfig } from '@explorer/src';
import { Palette } from '@mui/material';
import { useIntl } from 'react-intl';

export const AssociatedUserRow = ({
  user,
  palette,
  linkToUserPage = false,
}: {
  user: ControlClientInfoUser;
  palette: Palette;
  linkToUserPage?: boolean;
}) => {
  const { formatMessage } = useIntl();

  return (
    <Grid container alignItems="center" m={1}>
      <Grid container item alignItems="center">
        <Grid item mr={1}>
          <ActiveUserIcon active={user.is_active} deleted={!!user.deleted_on} />
        </Grid>
        <Grid item>
          <Typography
            variant="bodyS"
            color={linkToUserPage ? 'primary' : 'textPrimary'}
            sx={
              linkToUserPage
                ? { textDecoration: 'underline', textUnderlineOffset: '2px' }
                : undefined
            }
          >
            {user.email}
          </Typography>
        </Grid>
        {user.email ? (
          <Grid item>
            <CopyToClipboard size="small" copyMe={user.email} />
          </Grid>
        ) : null}
      </Grid>
      <Grid container item>
        <Grid item ml={2} mr={2}>
          <Typography variant="bodyXS" textColor={palette.grey[400]}>
            {formatMessage({ id: 'global.created-at' })}:{' '}
            {user.created_at ? (
              <TypographyDate
                variant="bodyXS"
                textColor={palette.grey[400]}
                date={user.created_at}
                format={appConfig.FORMATS.DATE}
              />
            ) : (
              formatMessage({ id: 'global.unknown' })
            )}
          </Typography>
        </Grid>
        <Grid item>
          <Typography variant="bodyXS" textColor={palette.grey[400]}>
            {formatMessage({ id: 'global.last-login' })}:{' '}
            {user.last_login ? (
              <TypographyDate
                variant="bodyXS"
                textColor={palette.grey[400]}
                date={user.last_login}
                format={appConfig.FORMATS.DATE}
              />
            ) : (
              formatMessage({ id: 'global.unknown' })
            )}
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  );
};
